import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const WebhookSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default WebhookSVG;
